import React from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";

export const SERIES = [
  ["tap", "Button taps", "#0EA5E9"],
  ["install", "App installs", "#10B981"],
  ["apk_download", "Android file downloads", "#0F172A"],
];

export const DailyChart = ({ daily }) => (
  <div data-testid="mobile-stats-daily-chart">
    <div className="flex flex-wrap gap-4 mb-3">
      {SERIES.map(([k, label, color]) => (
        <span key={k} className="inline-flex items-center gap-1.5 text-xs text-slate-500"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: color }} />{label}</span>
      ))}
    </div>
    <div className="h-48">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={daily} barGap={2}>
          <XAxis dataKey="label" tick={{ fill: "#64748B", fontSize: 11 }} axisLine={false} tickLine={false} />
          <Tooltip cursor={{ fill: "#F1F5F9" }} contentStyle={{ background: "#fff", border: "1px solid #E2E8F0", borderRadius: 12, fontSize: 12 }} />
          {SERIES.map(([k, label, color]) => <Bar key={k} dataKey={k} name={label} fill={color} radius={[4, 4, 0, 0]} maxBarSize={18} />)}
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export const ButtonTaps = ({ rows }) => {
  const max = Math.max(1, ...rows.map((r) => r.taps));
  return (
    <ul className="space-y-2.5" data-testid="mobile-stats-by-button">
      {rows.map((r, i) => (
        <li key={r.source} data-testid={`mobile-stats-button-${r.source}`}>
          <div className="flex items-center justify-between text-sm">
            <span className={i === 0 && r.taps ? "font-semibold text-slate-900" : "text-slate-600"}>{r.label}</span>
            <span className="font-mono text-slate-900">{r.taps}</span>
          </div>
          <div className="mt-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
            <div className="h-full rounded-full bg-sky-500 transition-[width] duration-500" style={{ width: `${(r.taps / max) * 100}%` }} />
          </div>
        </li>
      ))}
    </ul>
  );
};
